import React from 'react';
import { ImageProps } from '.';

const SvgFastshipEmblemSimpleKor = ({ size = 70, ...props }: ImageProps): JSX.Element => {
  return (
    <svg width={size} height={(size && Math.floor(size / 2.1875)) || 32} fill='none' viewBox='0 0 70 32' {...props}>
      <g clipPath='url(#FastshipEmblemSimpleKor_svg__a)'>
        <path
          fill='#3D4F6F'
          d='M53.986 0H16.014C7.168 0 0 7.163 0 16s7.17 16 16.014 16h37.972C62.831 32 70 24.837 70 16S62.83 0 53.986 0Z'
        />
        <path
          fill='#fff'
          d='M45.113 14.166h1.457v1.68h-1.457v7.413H43.12V8.844h1.993v5.322ZM50.842 21.39h8.212v1.615H48.816v-3.96h2.026v2.345ZM24.89 11.372c.376 0 .695.188.86.504l2.27 4.372a.8.8 0 0 1 .048.613l-.898 2.65a.606.606 0 0 1-.598.415h-1.525c-.078 0-.146.046-.165.117-.58 1.55-2.029 2.64-3.283 2.641-1.255 0-1.94-1.019-1.555-2.497.04-.144-.058-.261-.213-.261h-3.959c-.078 0-.145.046-.164.117-.58 1.55-2.029 2.641-3.284 2.641-1.254 0-1.94-1.019-1.554-2.497.039-.144-.058-.261-.212-.261H9.634c-.318 0-.512-.243-.415-.532l.646-1.938a.606.606 0 0 1 .599-.415h8.371c.445 0 .812-.243.948-.649l1.554-4.606a.605.605 0 0 1 .599-.414h2.954Z'
        />
        <path
          fill='#fff'
          fillRule='evenodd'
          d='M34.939 13.485h.918v-3.342h1.646v9.79h-4.225v-9.79h1.66v3.342Zm0 4.784h.918v-3.184h-.918v3.184ZM39.718 13.485h.934v-3.342h1.645v9.79h-4.21v-9.79h1.631v3.342Zm0 4.784h.934v-3.184h-.934v3.184Z'
          clipRule='evenodd'
        />
        <path
          fill='#fff'
          d='M60.336 18.253h-13.18v-1.615h13.18v1.615ZM58.738 13.153H50.81v1.03h8.197v1.52H48.8V11.71h7.912v-.982h-7.943V9.178h9.969v3.976ZM18.75 13.228c.319 0 .513.244.416.533l-.493 1.46c-.087.261-.318.414-.599.414H8.707c-.318 0-.512-.243-.415-.532l.493-1.46c.086-.261.318-.414.598-.415h9.367ZM20.025 9.443c.318 0 .51.243.414.531l-.492 1.461c-.087.262-.318.414-.598.414h-5.795c-.317 0-.51-.243-.414-.531l.493-1.46a.605.605 0 0 1 .599-.415h5.793Z'
        />
      </g>
      <defs>
        <clipPath id='FastshipEmblemSimpleKor_svg__a'>
          <path fill='#fff' d='M0 0h70v32H0z' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgFastshipEmblemSimpleKor;
